import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  fieldContainer: {
    marginBottom: theme.spacing(3),
    '& .myev-MuiFormHelperText-contained': {
      marginLeft: 0,
    },
  },

  heading: {
    height: '27px',
    maxWidth: '100%',
    borderRadius: '6px',
  },

  cardInputTextFullWidth: {
    width: '100%',
    height: '76px',
    borderRadius: '6px',
  },

  cardInputText: {
    maxWidth: '782px',
    height: '76px',
    borderRadius: '6px',
  },

  cardContainerSplit: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'nowrap',
    flexGrow: 1,
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },

  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    flexWrap: 'nowrap',
    flexGrow: 1,
  },

  cardTypeContainer: {
    width: theme.spacing(26),
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },

  cardTypeOptions: {
    borderRadius: 4,
    fontSize: 16,
    height: '76px',
    maxWidth: '782px',
  },

  cardNumberContainer: {
    flexGrow: 1,
    maxWidth: '558px',
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },

  cardNumberContainerFullWidth: {
    flexGrow: 1,
    '@media (max-width: 500px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },

  monthField: {
    borderRadius: 4,
    fontSize: 16,
    height: '100%',
    maxWidth: '782px',
  },

  yearField: {
    borderRadius: 4,
    fontSize: 16,
    height: '100%',
    maxWidth: '782px',
  },

  expirationContainer: {
    gap: '1rem',
    '@media (max-width: 640px)': {
      flexBasis: 0,
      flexGrow: 1,
    },
  },

  monthContainer: {
    width: theme.spacing(26),
    height: '108px',
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },

  yearContainer: {
    width: theme.spacing(26),
    height: '108px',
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },

  footer: {
    height: '76px',
    maxWidth: '100%',
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      height: '130px',
    },
  },
}));
